import { Component, OnInit} from '@angular/core';
import {COMMA, ENTER, SPACE} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { ProvidersService } from '../../services/providers.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';
import {ModalInvoicePdfComponent} from '../../modal-invoice-pdf/modal-invoice-pdf.component';
import {ModalUploadComponent} from '../../modal-upload/modal-upload.component';
import {OrderDetailComponent} from '../order-detail/order-detail.component';
import * as decode from 'jwt-decode';
import {TranslateService} from 'ng2-translate/ng2-translate';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-open-orders',
  templateUrl: './open-orders.component.html',
  styleUrls: ['./open-orders.component.scss']
})
export class OpenOrdersComponent implements OnInit {
  selectable = true;
  removable = true;
  addOnBlur = true;
  selectableRef = true;
  removableRef = true;
  addOnBlurRef = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  userId: any;
  userToken: any;
  temp = [];
  load = true;
  data: any = {};
  typeFileUpload: any;
  step = 0;
  loadBtn = false;
  checkedAll = false;
  arra = [];
  listReceptions = [];
  arrOc = [];
  arrRef = [];
  listSocieties = [];
  totalSelect = 0;
  total = 0;
  listCharges: any = null;
  providerDetail: any = {};
  providersList=[];
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  showExtranjero = false;
  language= 'es';

  constructor(
    private toastr: ToastrService,
    public dialog: MatDialog,
    private gralService: GeneralService,
    private provService: ProvidersService,
    public translate: TranslateService
  ){

    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    gralService.changeTextHead('SEARCHORDERSOPEN');
    translate.onLangChange.subscribe(lang => {
      if(lang.lang == 'en'){
        this.language= 'en';
      }

      if(lang.lang == 'es'){
        this.language= 'es';
      }
    });
    this.getSocieties();
  }

  ngOnInit() {
    this.loadProviders();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }


  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders(){
    this.provService.getProvidersNum(this.userToken).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }

  addProveedorSearch(option){
    let proveedor = option.split(' - ');
    this.data.provider = proveedor[0];
    this.myControl.setValue(proveedor[0]);

  }

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
        if(this.listSocieties.length == 1){
          this.data.society = this.listSocieties[0].NoSociedad;
          this.selectSociety();
        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(){
    const society = this.listSocieties.find(x => x.NoSociedad == this.data.society);
    if(society.NumProveedor){
      this.data.provider = society.NumProveedor;
    }
  }

  disabledProv(){
    let resp = false;
    if(this.data.society){
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.society);
      if(society.NumProveedor){
        resp = true;
      }
    }
    return resp;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if(value.length > 0 ){
      if(value.length < 10 || value.length > 10  ){
        let msg10digs = "La orden de compra debe ser de 10 dígitos";
        if(this.translate.currentLang == "en"){
          msg10digs = "The purchase order must be 10 digits";
        }else if(this.translate.currentLang == "es"){
          msg10digs = "La orden de compra debe ser de 10 dígitos";
        }
        this.toastr.info(msg10digs, '');
        input.value = '';
        return ;
      }
      // Add our fruit
      if ((value || '').trim()) {
        this.arrOc.push(value.trim());
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }

    }
  }

  remove(oc): void {
    const index = this.arrOc.indexOf(oc);
    if (index >= 0) {
      this.arrOc.splice(index, 1);
    }
  }

  addRef(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.arrRef.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  removeRef(oc): void {
    const index = this.arrRef.indexOf(oc);
    if (index >= 0) {
      this.arrRef.splice(index, 1);
    }
  }

  search(){
    if(this.arrOc.length < 1 && !this.data.oc){
      let msgRequired = "Favor de ingresar un número de orden de compra";
        if(this.translate.currentLang == "en"){
          msgRequired = "Please enter a purchase order number";
        }else if(this.translate.currentLang == "es"){
          msgRequired = "Favor de ingresar un número de orden de compra";
        }
      this.toastr.error(msgRequired, 'Error');
      return;
    }


    if(!this.data.provider || !this.data.society){
      let msgRequired = "Favor de agregar los datos obligatorios";
        if(this.translate.currentLang == "en"){
          msgRequired = "Please add the required data";
        }else if(this.translate.currentLang == "es"){
          msgRequired = "Favor de agregar los datos obligatorios";
        }
      this.toastr.error(msgRequired, 'Error');
      return;
    }

    this.step = 0;
    this.listReceptions = null;
    this.temp = null;
    this.loadBtn = true;

    let params = '';
    if(this.arrOc.length > 0){
      for(let g = 0; g < this.arrOc.length; g++){
        params = params+this.arrOc[g]+',';
      }
      params = params.substring(0, params.length - 1);
    }else{
      params = this.data.oc;
    }

    let paramsRef = null;
    if(this.arrRef.length > 0){
      paramsRef = '';
      for(let g = 0; g < this.arrRef.length; g++){
        paramsRef = paramsRef+this.arrRef[g]+',';
      }
      paramsRef = paramsRef.substring(0, paramsRef.length - 1);
    }else{
      paramsRef = this.data.ref;
    }

    this.provService.getProviderNum(this.userToken, this.data.provider ).then((res:any)=>{
      this.providerDetail = res.Entidad;

      if( this.providerDetail){
        this.showExtranjero =  this.providerDetail.Proveedor.EsExtranjero ;
      }
    });


    this.provService.searchOC(params, this.data.society, paramsRef, this.data.provider, 2, this.userId, this.userToken)
    .then((data) => {
      this.loadBtn = false;
      if(data['PO_Receptions_Available'].length > 0){
        this.listReceptions = data['PO_Receptions_Available'];
        this.temp = data['PO_Receptions_Available'];
        this.step = 1;
        this.getTotal();
        this.reorderDataExportExcel(this.listReceptions);
      }else{
        let msgRequired = "No existen recepciones disponibles";
        let title = "OC";
        if(this.translate.currentLang == "en"){
          title = "PO";
          msgRequired = "There are no receptions available";
        }else if(this.translate.currentLang == "es"){
          title = "OC";
          msgRequired = "No existen recepciones disponibles";
        }
      this.toastr.error(msgRequired, title);
      }
    }, (err) => {
      console.log(err);
      this.step = 0;
      this.listReceptions = null;
      this.temp = null;
      this.loadBtn = false;
      let msgRequired = err['error'][0].Response.Mensaje;
      
      if(this.translate.currentLang == "en"){
        if(err['error'][0].Response.Mensaje.includes('PO_ITEM_HISTORY')){
          msgRequired = "Purchase Order is invalid Failed to get SAP Orders: Error mapping PO_ITEM_HISTORY: Object reference not set for an instance of an object.";
        } 
        if(err['error'][0].Response.Mensaje.includes('folio')){
          msgRequired = "In open orders the folio number must be included";
        } 
      }else if(this.translate.currentLang == "es"){
        if(err['error'][0].Response.Mensaje.includes('PO_ITEM_HISTORY')){
          msgRequired = "La Orden de compra es invalida No se pudo obtener las Ordenes de SAP: Error al mapear PO_ITEM_HISTORY: Object reference not set to an instance of an object.";
        } 
        if(err['error'][0].Response.Mensaje.includes('folio')){
          msgRequired = "En la ordenes abiertas debe incluirse el número de folio.";
        } 
      }
      this.toastr.error(msgRequired, 'Error');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectAll(){
    for(let g = 0; g < this.listReceptions.length; g++){
      this.listReceptions[g].select = this.checkedAll;
      this.sumTot();
    }
  }

  uploadFiles(type){

    if( this.showExtranjero ){
      type = 'foreign';
    }

    this.arra = [];
    for(let g = 0; g < this.listReceptions.length; g++){
      if(this.listReceptions[g].select){
        const paramspush = {
          PrecioPorUnidad: this.listReceptions[g].PrecioPorUnidad,
          AnhoRecepcion: this.listReceptions[g].YearDocumento,
          Planta: this.listReceptions[g].Planta,
          Autorizador: this.listReceptions[g].UsuarioAprobador,
          UnidadDeMedida: this.listReceptions[g].Unidad_Medida,
          IdUsuarioSeleccion: 13,//TODO: Falta asignar el id de usuario logueado
          OrdenCompra: this.listReceptions[g].Orden_Compra,
          NumRecepcion: this.listReceptions[g].Numero_Documento,
          Posicion: this.listReceptions[g].Posicion_OrdenCompra,
          Cantidad: this.listReceptions[g].CantidadItem,
          PrecioUnitario: this.listReceptions[g].PrecioUnitario,
          IndicadorDeImpuesto: this.listReceptions[g].Indicador_IVA,
          Moneda: this.listReceptions[g].Moneda,
          Almacen: this.listReceptions[g].Almacen,
          NumSociedad: this.listReceptions[g].Sociedad,
          Posicion_DocumentoRef: this.listReceptions[g].Posicion_DocumentoRef,
          NumeroMaterial: this.listReceptions[g].NumeroMaterial,
          IdTipoOrden: this.listReceptions[g].IdTipoOrden,
          Referencia: this.listReceptions[g].Referencia,
          UnidadDeMedidaPrecio: this.listReceptions[g].Unidad_MedidaPrecio,
          ImporteLinea : this.listReceptions[g].Importe_Local,
          ToleranciaPorPorcentaje : this.listReceptions[g].ToleranciaPorPorcentaje,
          ToleranciaProveedor : this.listReceptions[g].ToleranciaProveedor
        };
        this.arra.push(paramspush);
      }
    }

    if(this.arra.length < 1){
        let msgRequired = "Favor de seleccionar por lo menos una recepción";
        let title = "Cargar factura";
        if(this.translate.currentLang == "en"){
          title = "Upload invoice";
          msgRequired = "Please select at least one reception";
        }else if(this.translate.currentLang == "es"){
          title = "Cargar factura";
          msgRequired = "Favor de seleccionar por lo menos una recepción";
        }
      this.toastr.error(msgRequired, title);
      return;
    }

    // aqui checar los cargos extra

    const params = {
      xmlBase64: null,
      pdfBase64: null,
      numeroProveedor: this.data.provider,
      numeroSociedad: this.data.society,
      claveEmpresa: 'SMP',
      tipoOrden: 2,
      cargosExtra: this.listCharges,
      datosOrdenCompra: { listaRecepcionesDisponibles: this.arra },
      IdUsuarioSeleccion: this.userId,
      language: this.language
    };

    const dialogRef = this.dialog.open(ModalUploadComponent, {
      minWidth: '70%',
      position: {
        top: '6%'
      },
      data: { type: type, data: params, totalSelect: this.totalSelect,language: this.language }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.data = {};
        this.step = 0;
        this.listReceptions = null;
        this.arrOc = [];
        this.temp = null;
        this.checkedAll = false;
      }
    });
  }

  sumTot(){
    let tot = 0;
    for(let g = 0; g < this.listReceptions.length; g++){
      if(this.listReceptions[g].select){
        tot += this.listReceptions[g].Importe_Local;
      }
    }
    this.totalSelect = tot;
  }

  getTotal(){
    setTimeout(() => {
      let tot = 0;
      for(let g = 0; g < this.listReceptions.length; g++){
        tot += this.listReceptions[g].Importe_Local;
      }
      this.total = tot;
    }, 500);
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrOc.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrOc.push(value.trim());
          }
        }
      })
  }

  pasteRef(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrRef.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrRef.push(value.trim());
          }
        }
      })
  }

  extraCharges(){
    const dialogRef = this.dialog.open(OrderDetailComponent, {
      minWidth: '80%',
      position: {
        top: '6%'
      },
      data: { type: 'extraCharges' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result.listCharges);
        this.listCharges = result.listCharges;
      }
    });
  }

  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listExcel);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName('carga_ordenes_abiertas'));
  }

  listExcel =  [];
  reorderDataExportExcel(lista){
    console.log(lista)
    this.listExcel =  [];

    for(let i = 0; i < lista.length; i++){


      let params = {
          "Pos OC": lista[i].Orden_Compra,
          "Doc. Recepción": lista[i].Numero_Documento,
          "Posición": lista[i].Posicion_OrdenCompra,
          "Referencia": lista[i].Referencia,
          "Fecha": lista[i].Fecha_Contable,
          "Cantidad": lista[i].Cantidad,
          "Precio": lista[i].PrecioUnitario,
          "Importe": lista[i].Importe_Local,
          "Descripción": lista[i].Descripcion
      }

      console.log(params)
      this.listExcel.push(params);
    }
    console.log(this.listExcel);
  }
}
